module.exports = __webpack_public_path__ + "static/media/nikkei-book.62f8a4ae.svg";